import React, { Component } from "react";
import * as Sentry from "@sentry/browser";
import GlobalError from "./GlobalError";
import axios from "axios";

Sentry.init({
  dsn: process.env.SENTRY_URL,
  environment: process.env.ENV
});

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      message: null,
      title: null
    };
  }
  componentDidMount() {}
  componentDidCatch(error, errorInfo) {
    //console.log(errorInfo);
    if (error !== 503) {
      this.setState(
        {
          title: null,
          message: null
        },
        () => {
          this.setState({ error });
        }
      );
    } else {
      let self = this;
      axios
        .get(
          "https://s3-eu-west-1.amazonaws.com/locale-static/system/messages/service.json",
          { headers: { "Access-Control-Allow-Origin": "*" } }
        )
        .then(response => {
          if (response && response.service && response.service.message) {
            const service = response.service.message;
            self.setState({
              message: service.message,
              title: service.title,
              error
            });
          }
        })
        .catch(error => {
          self.setState({
            title: "We're super popular right now!",
            message:
              "Sorry, we're getting lots of visitors to our site right now. We're just starting out and we never anticipated this much support from you. We'll be back asap! #thankyou",
            error
          });
        });
    }
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }
  render() {
    const { error, message, title } = this.state;
    if (error) {
      return <GlobalError message={message} title={title} />;
    } else {
      return this.props.children;
    }
  }
}
